import { render, staticRenderFns } from "./ROICalculator.vue?vue&type=template&id=2f193e3e&scoped=true"
import script from "./ROICalculator.vue?vue&type=script&lang=ts"
export * from "./ROICalculator.vue?vue&type=script&lang=ts"
import style0 from "./ROICalculator.vue?vue&type=style&index=0&id=2f193e3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f193e3e",
  null
  
)

export default component.exports